import {CronWorkflowContainer} from './components/cron-workflow-container';

export default {
    component: CronWorkflowContainer
};
